import React, { useEffect } from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { useInView } from 'react-intersection-observer';

import virginiaMap from '../../assets/virginiaMapBg.png';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingBottom: '5.56rem',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      backgroundColor: theme.palette.common.background,
      paddingBottom: '4rem'
    }
  },
  epInfoCont: {
    width: '81%',
    marginTop: '4.25rem'
  },
  epHeaderAndMap: {
    width: '50%',
    paddingLeft: '7rem',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '3.5rem'
    },
    [theme.breakpoints.down('sm')]: {
      width: '71.5%'
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '0px',
      width: '100%'
    }
  },
  mapImgCont: {
    width: '327px',
    marginTop: '-1rem',
    marginLeft: '0rem',
    [theme.breakpoints.down('xs')]: {
      width: '98%',
      marginLeft: '0px'
    }
  },
  stateTitle: {
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem'
    }
  },
  headerDescriptionCont: {
    width: '50%',
    marginTop: '4rem',
    [theme.breakpoints.down('md')]: {
      marginTop: '2rem',
      width: '71.5%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '98%',
      marginTop: '2.4rem'
    }
  },

  numStatCont: {
    marginTop: '1rem'
  },
  nums: {
    width: '35%',
    maxWidth: '160px',
    [theme.breakpoints.down('md')]: {
      width: '30%'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  numsPG: {
    width: '61%',
    marginLeft: '1rem',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
      marginTop: '1.4rem',
      width: '61.25%'
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: '0px',
      marginTop: '1.4rem',
      width: '100%'
    }
  },
  sourceCont: {
    marginTop: '4.8rem',
    [theme.breakpoints.down('xs')]: {
      marginTop: '2rem'
    }
  },
  // ================================================
  subhead5: {
    ...theme.typography.subhead5,
    color: '#BFDA1C',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    }
  },
  stat1: {
    ...theme.typography.stat1,
    [theme.breakpoints.down('md')]: {
      fontSize: '3.7rem'
    },
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.mobile.stat1
    }
  },
  stat2: {
    ...theme.typography.stat2,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.mobile.stat2
    }
  },
  source: {
    ...theme.typography.caption
  }
}));

const Episode1 = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down('xs'));
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesMD = useMediaQuery(theme.breakpoints.down('md'));
  const { ref, inView } = useInView({ threshhold: 0 });

  useEffect(() => {
    if (inView) {
      props.setActive(3);
    }
  });

  return (
    <>
      <Grid id="virginia" ref={ref} justifyContent="center" container className={classes.wrapper}>
        <div style={{ borderTop: '1px solid #7B7B7B ', width: '81%' }} />
        <Grid
          container
          direction={matchesSM ? 'column' : undefined}
          alignItems={matchesSM ? 'center' : undefined}
          justifyContent="center"
          className={classes.epInfoCont}
        >
          <Grid
            container
            direction="column"
            alignItems={matchesMD ? 'center' : undefined}
            className={classes.epHeaderAndMap}
          >
            <Grid item>
              <Typography className={classes.subhead5}>EPISODE 3</Typography>
            </Grid>
            <Grid item>
              <Typography variant="h1" className={classes.stateTitle}>
                Richmond, Virginia
              </Typography>
            </Grid>
            <Grid item className={classes.mapImgCont}>
              <img src={virginiaMap} alt="map indicating Alabama" style={{ width: '100%' }} />
            </Grid>
          </Grid>
          <Grid container direction="column" className={classes.headerDescriptionCont}>
            <Grid item>
              <Typography className={classes.stat2}>
                Black men in Virginia are{' '}
                <span style={{ fontFamily: 'neuePlakB' }}>5.5 times more likely</span> than white
                men to be living with HIV.
              </Typography>
            </Grid>
            <Grid item>
              <Typography className={classes.stat2} style={{ marginTop: '1.5rem' }}>
                Black women in Virginia are{' '}
                <span style={{ fontFamily: 'neuePlakB' }}>15.1 times more likely</span> than white
                women to be living with HIV.
              </Typography>
            </Grid>
            <Grid
              container
              direction={matchesXS ? 'column' : undefined}
              alignItems={matchesXS ? 'flex-start' : matchesMD ? 'center' : undefined}
              className={classes.numStatCont}
            >
              <Grid item className={classes.nums}>
                <Typography className={classes.stat1}>49x</Typography>
              </Grid>
              <Grid item className={classes.numsPG}>
                <Typography className={classes.stat2}>
                  Transgender women are <span style={{ fontFamily: 'neuePlakB' }}>49 times </span>as
                  likely to be living with HIV compared to the general population.
                </Typography>
              </Grid>
              <Grid item className={classes.sourceCont}>
                <Typography className={classes.source}>
                  {' '}
                  <a
                    href="https://map.aidsvu.org/map"
                    target="_blank"
                    rel="sponsored"
                    style={{ color: '#979797' }}
                  >
                    Source: AIDSVu.org
                  </a>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Episode1;
